module.exports = __webpack_public_path__ + "img/9791158886820.cf2e427a.jpg";